/* Autoplay videos only while they're on screen. Saves battery and stops a
   page full of clips from decoding all at once. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting && !reduce) {
          /* The clips ship preload="none". Shopify serves the full HD source, so
             three of them on one page was ~95MB fetched before anyone scrolled.
             Start fetching only once the clip is actually on screen. */
          if (v.preload === 'none') {
            v.preload = 'auto';
            v.load();
          }
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    },
    { threshold: 0.25 }
  );

  var mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

  function bind(scope) {
    (scope || document).querySelectorAll('[data-autoplay-video] video').forEach(function (v) {
      if (v.dataset.apBound) return;
      /* Opted out on phones: leave preload="none" alone so the poster shows and
         not a single video byte is fetched. */
      /* Phones: never fetch a clip until it is tapped. The homepage was pulling
         122MB of video on a phone before anyone scrolled -- posters are free. */
      if (mobile) {
        v.dataset.apBound = '1';
        v.removeAttribute('autoplay');
        v.preload = 'none';
        var box = v.closest('[data-autoplay-video]') || v;
        box.style.cursor = 'pointer';
        box.addEventListener('click', function (e) {
          if (e.target.closest('button, a')) return;
          if (v.paused) { if (v.preload === 'none') { v.preload = 'auto'; v.load(); } var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
        return;
      }
      v.dataset.apBound = '1';
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.removeAttribute('autoplay');
      if (reduce) { v.pause(); }
      io.observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else { bind(document); }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
